import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetBreederDetailAction} from '../action';

function* execute({payload}: GetBreederDetailAction): SagaIterator {
    const response = yield* call(Api.getUserProfileBreederRoleFarmsBinding, {userRoleId: payload});

    if (response.isSuccess) {
        const optData = opt(response.data);
        yield* put(adminAction.getBreederDetailSuccess(optData));
        yield* put(adminAction.setManagementBreedersUsers(optData.prop('user').toArray()));
        yield* put(adminAction.setManagementBreedersRoles(optData.prop('role').toArray()));
    } else {
        yield putAll(showBeError(response, t('userDetail')('loadBreederDetail')));
    }
}
/** Runs the admin saga that loads the selected breeder-management detail. */
export function* getManagementBreederDetailSaga(): SagaIterator {
    yield takeLatestF('admin/GET_BREEDER_DETAIL', execute);
}
